import React from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Ticker from "@/components/Ticker";
import LiveStatusBar from "@/components/LiveStatusBar";
import NewsTicker from "@/components/NewsTicker";
import BrandsGrid from "@/components/BrandsGrid";
import SocialFeed from "@/components/SocialFeed";
import EmbedSocialFeed from "@/components/EmbedSocialFeed";
import KitchenTour from "@/components/KitchenTour";
import LatestNews from "@/components/LatestNews";
import WalkInPanel from "@/components/WalkInPanel";
import HowItWorks from "@/components/HowItWorks";
import About from "@/components/About";
import JoinTheClub from "@/components/JoinTheClub";
import PartnerWithUs from "@/components/PartnerWithUs";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import ClubPopup from "@/components/ClubPopup";

const HAS_EMBED_SOCIAL = !!process.env.REACT_APP_EMBEDSOCIAL_WIDGET_ID;

export default function Home() {
  return (
    <main className="bg-[var(--bg)] text-[var(--text)] min-h-screen" data-testid="home">
      <Nav />
      <Hero />
      <Ticker />
      <LiveStatusBar />
      <NewsTicker />
      <BrandsGrid />
      <KitchenTour />
      <LatestNews />
      {HAS_EMBED_SOCIAL ? <EmbedSocialFeed /> : <SocialFeed />}
      <WalkInPanel />
      <HowItWorks />
      <About />
      <JoinTheClub />
      <PartnerWithUs />
      <Footer />
      <CookieBanner />
      <ClubPopup />
    </main>
  );
}
